import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class ProductVariantBadges extends HTMLElement {
  /** @type {Element | null} */
  #eventTarget = null;

  connectedCallback() {
    this.#eventTarget = this.closest('.shopify-section, dialog');
    this.#eventTarget?.addEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  disconnectedCallback() {
    // Use the cached reference — this.closest() returns null once
    // the element has been removed from the DOM (e.g. by replaceWith).
    this.#eventTarget?.removeEventListener(ThemeEvents.variantUpdate, this.updateBadges);
    this.#eventTarget = null;
  }

  /** @param {CustomEvent} event */
  updateBadges = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBadges = event.detail.data.html.querySelector('product-variant-badges');

    if (!newBadges) return;

    // Clone so morph doesn't move children out of the parsed HTML.
    // media-gallery also listens for variantUpdate and does replaceWith()
    // using the same parsed HTML — if we morph from the original, its
    // children get moved into the live DOM here, leaving the parsed copy
    // empty. The subsequent replaceWith then inserts an empty badge element.
    morph(this, newBadges.cloneNode(true), { childrenOnly: true });
  };
}

if (!customElements.get('product-variant-badges')) {
  customElements.define('product-variant-badges', ProductVariantBadges);
}
